import { useMemo } from 'react';
import styled from 'styled-components';
import { CALYPSO_LIGHT } from 'HubStyleTokens/colors';

// @ts-expect-error not typed

import { isSucceeded } from '../../async-data/operators/statusComparators';
import { ThirdPartySettingsNumbersHelpDesk } from './ThirdPartySettingsNumbersHelpDesk';
import { TICKET_OBJECT_TYPE_ID } from '../constants/ObjectTypeIds';
import openThirdPartyWidget from 'calling-global-api/methods/openThirdPartyWidget';
import { logError } from 'calling-error-reporting/report/error';
import { getIn } from '../../utils/getIn';
import { hasCallableRecords } from '../../callees/utils/calleeOperators';
import { getPhoneNumberProperties, getPropertyName, getObjectId, getObjectTypeId } from 'calling-lifecycle-internal/callees/operators/calleesOperators';
import updateThirdPartySubject from 'calling-global-api/methods/updateThirdPartySubject';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const Wrapper = styled.div.withConfig({
  displayName: "ThirdPartyHelpDeskPopover__Wrapper",
  componentId: "sc-1vsh30x-0"
})(["max-width:615px;"]);
const Options = styled.div.withConfig({
  displayName: "ThirdPartyHelpDeskPopover__Options",
  componentId: "sc-1vsh30x-1"
})([".option-item:hover{background-color:", ";}"], CALYPSO_LIGHT);
export const getSelectedProviderFromApplications = (appId, apps) => {
  const found = appId && apps.find(app => app.appId === appId);
  return found || null;
};
export const ThirdPartyHelpDeskPopover = props => {
  const {
    subjectId,
    calleeOmnibusResult,
    selectedCallProviderAppId,
    calleeOmnibusStatus
  } = props;
  const calleesData = getIn(['callableObjectAndAssociations'], calleeOmnibusResult);
  const callingProviders = getIn(['installedCallingSettings', 'installedCallingApplications'], calleeOmnibusResult, []);
  const selectedCallProvider = useMemo(() => {
    return isSucceeded(calleeOmnibusStatus) ? getSelectedProviderFromApplications(selectedCallProviderAppId, callingProviders) : null;
  }, [callingProviders, selectedCallProviderAppId, calleeOmnibusStatus]);
  const hasRecords = useMemo(() => hasCallableRecords(calleesData), [calleesData]);
  const renderNoCalleesMessage = () => {
    return null;
    // TODO: Implement NoCalleesPrompt in CALL-6009
    // return (
    //   <NoCalleesPrompt
    //     subjectId={Number(subjectId)}
    //     objectTypeId={objectTypeId}
    //     shouldShowAddNumber={false}
    //   />
    // );
  };
  const renderCallees = () => {
    const {
      appIdentifier,
      onCallButtonClick,
      isKnownVisitor,
      visitorPhoneNumber,
      threadId
    } = props;
    const startOutboundCall = ({
      numberIdentifier,
      callableObject
    }) => {
      updateThirdPartySubject({
        objectId: Number(subjectId) || 0,
        objectTypeId: TICKET_OBJECT_TYPE_ID,
        threadId: Number(threadId) || 0
      }).catch(e => {
        logError(e);
      });
      const phoneNumberProperties = getPhoneNumberProperties(callableObject);
      const numberPropertyName = getPropertyName(numberIdentifier);
      const toSubject = {
        objectId: Number(getObjectId(callableObject)),
        objectTypeId: getObjectTypeId(callableObject),
        ticketId: Number(subjectId) || 0,
        phoneNumberProperties,
        numberPropertyName,
        threadId: Number(threadId) || 0
      };
      openThirdPartyWidget({
        toSubject,
        startCall: true,
        addPhoneNumber: false,
        callingProvider: selectedCallProvider || undefined
      }).catch(e => {
        logError(e);
      });
    };
    return /*#__PURE__*/_jsx(_Fragment, {
      children: !isSucceeded(calleeOmnibusStatus) || hasRecords || visitorPhoneNumber ? /*#__PURE__*/_jsx(Options, {
        className: "flex-column",
        "data-selenium-test": "call-settings-numbers-options",
        "data-test-id": "call-settings-numbers-options",
        children: /*#__PURE__*/_jsx(ThirdPartySettingsNumbersHelpDesk, {
          appIdentifier: appIdentifier,
          onCallButtonClick: onCallButtonClick,
          defaultFromNumber: undefined,
          visitorPhoneNumber: visitorPhoneNumber,
          isKnownVisitor: isKnownVisitor,
          calleesData: calleesData,
          startOutboundCall: startOutboundCall,
          selectedCallProvider: selectedCallProvider
        })
      }) : renderNoCalleesMessage()
    });
  };
  return /*#__PURE__*/_jsx(Wrapper, {
    children: renderCallees()
  });
};